import { Button, Icon, Spinner, Text } from "@alpacahq/ui/old";

import { FAQ } from "../../../../../components/common/FAQ";
import { Layout } from "../../common/Layout";
import { ACH_FAQ } from "../../link/ach";
import { FromTo } from "../../transferForm/FromTo";
import { ReasonFields } from "../../transferForm/ReasonFields";
import { TransferFormButtons } from "../../transferForm/TransferFormButtons";
import { TransferFormFields } from "../../transferForm/TransferFormFields";
import { IraDistributionFields } from "../ira/IraDistributionFields";
import type { useAchWithdrawController } from "./AchWithdraw.controller";

export type AchWithdrawPresentationProps = ReturnType<
  typeof useAchWithdrawController
>;

export const AchWithdrawPresentation = ({
  isLoading,
  hasACHRelationship,
  achRelationship,
  alpacaAccountInfo,
  form,
  isIRA,
  eligibleReasons,
  isSubmitChecked,
  setIsSubmitChecked,
  isSubmitEnabled,
  isConfirmDisabled,
  amountString,
  withdrawable,
  onBack,
  onSubmit,
}: AchWithdrawPresentationProps) => {
  const backButton = (
    <Button variant="secondary" onClick={onBack} className="mb-8">
      <Icon name="ArrowLeftCircle" className="mr-2" />
      Back
    </Button>
  );

  return (
    <Layout
      title="Withdraw Funds via ACH"
      subtitle="Withdraw funds from your Alpaca account using ACH connection."
      className="p-2"
      faq={<FAQ faq={ACH_FAQ} />}
    >
      {isLoading ? (
        <Spinner className="mx-auto" />
      ) : !hasACHRelationship ? (
        <div className="flex flex-col gap-4">
          <Text>No ACH connection Found.</Text>
          {backButton}
        </div>
      ) : (
        <>
          {backButton}
          <form
            onSubmit={onSubmit}
            className="w-full max-w-lg rounded border border-gray-200 p-4"
          >
            <FromTo
              from={alpacaAccountInfo}
              to={{
                name: achRelationship?.brand_name ?? "",
                account: achRelationship?.account_name ?? "",
                imgSrc: achRelationship?.logo,
              }}
              className="mb-8"
            />
            {isIRA ? (
              <>
                <IraDistributionFields
                  form={form}
                  eligibleReasons={eligibleReasons}
                  areInputsDisabled={isSubmitChecked}
                />
                <TransferFormFields
                  form={form}
                  isInputDisabled={isSubmitChecked}
                  withdrawableAmount={withdrawable}
                />
              </>
            ) : (
              <>
                <TransferFormFields
                  form={form}
                  isInputDisabled={isSubmitChecked}
                  withdrawableAmount={withdrawable}
                />
                <ReasonFields form={form} withdrawableAmount={withdrawable} />
              </>
            )}
            <TransferFormButtons
              direction="withdrawal"
              isSubmitChecked={isSubmitChecked}
              setIsSubmitChecked={setIsSubmitChecked}
              isSubmitEnabled={isSubmitEnabled}
              isConfirmDisabled={isConfirmDisabled}
              amount={amountString}
            />
          </form>
        </>
      )}
    </Layout>
  );
};
